var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('b-button',{attrs:{"variant":"success","type":"submit","size":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Save Payment Method")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }